/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-10-30 11:02:50
 */
import React, { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import DownloadItem from './DownloadItem'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { fetchExportUserHistory } from '../../../actions/group'

export default ({ visible, onClose }) => {
  const groupID = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()
  const [data, setData] = useState([])

  useEffect(() => {
    if (visible) {
      dispatch(
        fetchExportUserHistory({
          groupID
        })
      ).then((res) => {
        setData(res.files || [])
      })
    }
  }, [visible])

  return (
    <Drawer
      open={visible}
      getContainer={false}
      onClose={onClose}
      size={440}
      title={
        <div className="download-history-header">
          <div className="title">下载记录</div>
          <div className="subtitle">历史下载记录最长保留7天</div>
        </div>
      }
    >
      {data.map(({ fileName, exportURL }, index) => (
        <DownloadItem
          key={fileName}
          fileName={fileName}
          exportURL={exportURL}
        />
      ))}
    </Drawer>
  )
}
